module.exports = __webpack_public_path__ + "static/media/_MIC2768.image.7de88c0e.png";